import { memo } from 'react';
import classNames from 'classnames';
import { SecondaryButton } from '@JohnLewisPartnership/jl-design-system/elements/button/Button';
import { FilterOutlined } from '@JohnLewisPartnership/jl-design-system/components/icons/FilterOutlined';

import styles from './PrimaryFacet.module.scss';

type Props = {
  className: 'mobile' | 'tablet';
  handlePrimaryFacetClick: (className: string) => void;
  primaryFacetDisplayName: string;
};

const PrimaryFacet = ({
  className,
  handlePrimaryFacetClick,
  primaryFacetDisplayName,
}: Props) => {
  return (
    <SecondaryButton
      data-testid={`filters-button-${className}`}
      className={classNames(styles.primaryFacet, styles[className])}
      onClick={() => handlePrimaryFacetClick(className)}
    >
      <span className={styles.filterIcon}>
        <FilterOutlined
          title={`Amend ${primaryFacetDisplayName} filter`}
          size="medium"
        />
      </span>
      {primaryFacetDisplayName}
    </SecondaryButton>
  );
};

export default memo(PrimaryFacet);
